import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-3" }
const _hoisted_2 = { class: "text-left text-base text-white" }
const _hoisted_3 = { class: "mb-3 PlusMinusGrid place-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "text-red-500 fas fa-minus" })
], -1)
const _hoisted_5 = { class: "flex flex-row-reverse justify-evenly items-center" }
const _hoisted_6 = { class: "flex flex-row justify-evenly items-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "text-center text-green-500 fas fa-plus" })
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.negativeColour, (i) => {
          return (_openBlock(), _createBlock("div", {
            class: "flex-grow bg-red-500 mx-1 rectangle",
            key: i
          }))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.negativeGrey, (i) => {
          return (_openBlock(), _createBlock("div", {
            class: "flex-grow bg-gray-500 mx-1 rectangle",
            key: i
          }))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.positiveColour, (i) => {
          return (_openBlock(), _createBlock("div", {
            class: "flex-grow bg-green-500 mx-1 rectangle",
            key: i
          }))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.positiveGrey, (i) => {
          return (_openBlock(), _createBlock("div", {
            class: "flex-grow bg-gray-500 mx-1 rectangle",
            key: i
          }))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _hoisted_7
    ])
  ]))
}